import React from 'react';

import LoginForm from '../components/auth/LoginForm';


const AuthPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-[#FC7A69]/10 via-[#221E45]/5 to-[#FC7A69]/5 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
    <div className="absolute inset-0">
      <div className="absolute top-0 left-0 w-72 h-72 bg-gradient-to-r from-[#FC7A69] to-[#221E45] rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
      <div className="absolute top-0 right-0 w-72 h-72 bg-gradient-to-r from-[#221E45] to-[#FC7A69] rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-2000"></div>
      <div className="absolute bottom-0 left-1/2 w-72 h-72 bg-gradient-to-r from-[#FC7A69]/80 to-[#221E45]/80 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-4000"></div>
    </div>
    <div className="relative z-10 w-full max-w-md">
      <LoginForm />
    </div>
  </div>
);

export default AuthPage;